import { Home as HomeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useAuthStore } from '@/shared/auth/auth.store';
import { NotFoundIllustration } from '@/shared/components/illustrations/not-found-illustration';
import { Button } from '@/shared/components/ui/button';

/**
 * Tela 404 — capturada pela rota `*` em `routes.tsx`.
 *
 * Polish Phase 15:
 *  - Ilustracao SVG inline ("Map Pin com glow", estilo Obsidian Pulse).
 *  - Kicker "Erro 404" em primary uppercase (espelha mock HTML em
 *    web-version-final-ui/desktop/final/edge/404.html).
 *  - CTA primario aponta para `/home` se autenticado, `/welcome` caso
 *    contrario — evita jogar usuario deslogado dentro do shell e tirar
 *    o redirect para login (que entao causa um flash extra).
 *  - testID `not-found-screen` (alem do legacy `not-found` ja em uso por
 *    spec mais antigo) — deixa ambos para nao quebrar testes existentes.
 *
 * Feito a partir da OPCAO A "Map Pin com glow" (ver
 * __mocks__/edge/404/option-a.tsx).
 */
export function NotFound() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const homeHref = isAuthenticated ? '/home' : '/welcome';
  const homeLabel = isAuthenticated ? 'Voltar para o início' : 'Voltar para o welcome';

  return (
    <main
      className="flex min-h-screen items-center justify-center bg-canvas px-6 py-12"
      data-testid="not-found-screen"
    >
      <div
        className="flex max-w-xl flex-col items-center gap-5 text-center"
        data-testid="not-found"
      >
        <NotFoundIllustration />
        <p className="text-label-md font-bold uppercase tracking-[0.18em] text-primary">Erro 404</p>
        <h1 className="text-display-lg text-on-surface">Página não encontrada</h1>
        <p className="max-w-md text-body-md text-secondary-text">
          O endereço que você acessou não existe ou foi movido. Confira a URL e tente novamente, ou
          volte para a {isAuthenticated ? 'tela inicial' : 'página de boas-vindas'}.
        </p>
        <div className="mt-2">
          <Button asChild variant="primary" size="md">
            <Link to={homeHref} data-testid="not-found-home-link">
              <HomeIcon size={16} aria-hidden />
              {homeLabel}
            </Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
